import React from 'react';
import { Building2 } from 'lucide-react';
import { NO_LOCATION_NAME } from '../lib/locationLabel';

/**
 * The client's own name for a delivery site, shown above the address on every
 * staff screen that handles goods. A walk-in order is tagged so staff know why
 * the name reads differently; an order with no resolvable location says so
 * instead of falling back to the company name.
 */
export const LocationLine = ({ name, source, address, clientName, testId, className = '' }) => {
  // A walk-in order's "location" IS its customer name, which is often already
  // the client cell right above — show the tag alone instead of repeating it.
  const repeatsClient = Boolean(name) && (name || '').trim() === (clientName || '').trim();
  return (
    <div className={`min-w-0 ${className}`} data-testid={testId}>
      <div className="flex items-center gap-1.5 flex-wrap">
        <Building2 className="h-3.5 w-3.5 text-gray-400 shrink-0" />
        {name ? (
          <>
            {!repeatsClient && <span className="text-sm font-medium text-gray-900">{name}</span>}
            {source === 'custom' && (
              <span className="text-[10px] uppercase tracking-wide font-semibold text-purple-700 bg-purple-100 px-1.5 py-0.5 rounded">
                Custom order
              </span>
            )}
          </>
        ) : (
          <span className="text-xs italic text-gray-400">{NO_LOCATION_NAME}</span>
        )}
      </div>
      {address && <p className="text-xs text-gray-500 mt-0.5 pl-5">{address}</p>}
    </div>
  );
};

export default LocationLine;
